<template>
    <LayoutSub className="data_business">
        <SubpageTitleContainer title="데이터 사업"
            subText="100만 가맹점 네트워크와 월간 3억건 이상의 결제 데이터를 바탕으로 부가가치 창출하고 새로운 사업기회를 발굴합니다.">
        </SubpageTitleContainer>

        <SubSection type="wide">
            <SubTitle3 listStyle="dot">서비스 개요</SubTitle3>
            <div class="image_box">
                <img src="@/assets/pc_data_business_image01.png" alt="" />
            </div>
            <div class="mo_img_box">
                <img src="@/assets/mo_data_business_image01.png" alt="" />
            </div>
        </SubSection>
        <div class="sub_2grid">
            <SubSection classList="pb-0">
                <SubTitle3 listStyle="dot">KICC 데이터스토어 (https://datastore.kicc.co.kr)</SubTitle3>
                <RedLineButton :type="`inbound`" :text="`바로가기`" href="https://datastore.kicc.co.kr" />
                <div class="gray_image_box">
                    <img src="@/assets/data_business_image02.png" alt="" />
                </div>
                <ul>
                    <li>KICC 데이터스토어는 KICC의 데이터 현황을 한눈에 살펴볼 수 있는 사이트로 KICC 데이터 상품을 확인할 수 있음</li>
                    <li>데이터 상품에 대한 소개와 활용 방법에 대한 예시를 제시하고 데이터 수요자와 소통할 수 있는 창구를 제공</li>
                </ul>
            </SubSection>
            <SubSection classList="pb-0">
                <SubTitle3 listStyle="dot">KICC 상권분석 서비스 (https://shopinfo.kicc.co.kr) </SubTitle3>
                <RedLineButton :type="`inbound`" :text="`바로가기`" href="https://shopinfo.kicc.co.kr" />
                <div class="gray_image_box">
                    <img src="@/assets/data_business_image03.png" alt="" />
                </div>
                <ul>
                    <li>KICC 상권분석 서비스는 KICC의 결제 데이터와 외부 데이터(인구 정보, 부동산 정보 등)를 결합하여 지역기반의 상권정보를 제공</li>
                    <li>지역별 결제동향과 인구정보, 부동산 임대료를 확인할 수 있어 예비 창업자나 소상공인이 경영에 필요한 정보를 확인할 수 있음</li>
                </ul>
            </SubSection>
        </div>
    </LayoutSub>
</template>
<script>
import RedLineButton from '@/components/RedLineButton.vue';
import SubpageTitleContainer from '@/components/SubpageTitleContainer.vue';
import SubSection from '@/components/SubSection.vue';
import SubTitle3 from '@/components/SubTitle3.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';

export default {
    components: {
        LayoutSub,
        SubpageTitleContainer,
        SubSection,
        SubTitle3,
        RedLineButton,
    },
};
</script>
<style lang="scss" scoped></style>
